import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { Grid } from '@material-ui/core';
import GridContainer from '../GridContainer';
import { useDispatch } from 'react-redux';
import '../../pages/Users/NewUser/newuser.scss';

const UploadPdfDialog = ({ open, handleClose, handleOk, title, onUpload }) => {
  const dispatch = useDispatch();
  const [talkTitle, setTalkTitle] = useState('');
  const [file, setFile] = useState(null);

  const save = () => {
    const formData = new FormData();
    formData.append('title', talkTitle);
    formData.append('file', file);
    dispatch(onUpload(formData, handleOk));
  };

  return (
    <Dialog maxWidth="sm" fullWidth onClose={handleClose} open={open}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        <GridContainer className="newuser__container">
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Title"
              variant="outlined"
              value={talkTitle}
              onChange={(e) => setTalkTitle(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <input type="file" accept=".pdf" onChange={(e) => setFile(e.target.files[0])} />
            {file && <p>{file.name}</p>}
          </Grid>
        </GridContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={save} color="primary" disabled={!talkTitle || !file}>
          Upload
        </Button>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

UploadPdfDialog.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  handleOk: PropTypes.func,
  title: PropTypes.string,
  onUpload: PropTypes.func.isRequired
};

export default UploadPdfDialog;
